<template>
  <b-card :header="title" class="mb-0 h-100" body-class="pb-0">
    <b-alert :show="errors.any()" variant="danger" class="px-4">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">
          {{ err }}
        </li>
      </ul>
    </b-alert>

    <b-row>
      <b-col
        v-for="item in model"
        :key="item.id"
        md="6"
        class="mb-3"
      >
        <b-card
          bg-variant="light"
          class="border-0 h-100 mb-0"
          header-class="border-0"
        >
          <template v-slot:header>
            <div class="d-flex align-items-center justify-content-between">
              <div>
                {{ $t(`shared.documents.${item.type}`) }}
                <required-symbol v-if="item.required"/>
              </div>

              <small class="text-muted">
                <template v-if="item.approved">
                  <font-awesome-icon icon="check" class="align-middle text-success" :class="{'mr-1': $dir.ltr, 'ml-1': $dir.rtl}"/>
                  {{ $t('shared.approved') }}
                </template>

                <template v-else>
                  <font-awesome-icon icon="times" class="align-middle" :class="{'mr-1': $dir.ltr, 'ml-1': $dir.rtl}"/>
                  {{ $t('shared.disapproved') }}
                </template>
              </small>
            </div>
          </template>

          <b-form-group>
            <b-input-group :prepend="$t('shared.name')">
              <b-form-input
                v-model="item.name"
                dir="auto"
                :name="$t('shared.documents.documentName', { document: item.name })"
                v-validate="item.required ? 'required' : null"
              />
            </b-input-group>
          </b-form-group>

          <uploader
            multiple
            :name="$t('shared.documents.documentAttachments', { document: item.name })"
            bg-variant="white"
            v-validate="item.required ? 'required' : null"
            :required="item.required"
            v-model="item.attachments"
          />
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import Uploader from '@/components/shared/Uploader'

export default {
  name: 'DocumentsEditor',
  components: {
    Uploader
  },
  props: {
    value: Array,
    title: String
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    validateAll() {
      return this.$validator.validateAll()
    }
  }
}
</script>
